"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (item) {
    var parentSubtotal = item.item.price * item.item.quantity;
    if (!item.children) {
        return parentSubtotal;
    }
    return parentSubtotal + item.children.reduce(function (sum, child) { return sum + child.price * child.quantity; }, 0);
});
